import { apiGet } from "@/fetch/api";
import {
  introduction,
  history,
  relic,
  legend,
  scenicTag,
  scenicDataMap,
  scenicList,
  mapTag,
  mapData
} from "./data/xihu";

const CorpCode = 'westlaketour'
const dataWrapper = data => {
  return new Promise(resolve => {
    resolve(data);
  });
};

function getIntroduction() {
  return dataWrapper(introduction);
}
function getHistory() {
  return dataWrapper(history);
}
function getRelic() {
  return dataWrapper(relic);
}
function getLegend() {
  return dataWrapper(legend);
}
function getScenicTagList() {
  return dataWrapper(scenicTag);
}
function getScenicDes(type) {
  const data = scenicDataMap[type].text;
  return dataWrapper(data);
}
function getScenicList(type) {
  const data = scenicDataMap[type].list;
  return dataWrapper(data);
}
function getScenicDetail(id) {
  const data = scenicList.find(item => item.id === id);
  const result = {
    imgList: [],
    text: "",
    title: ""
  };
  if (data) {
    result.imgList = data.imgList;
    result.text = data.detail;
    result.title = data.title;
  }
  return dataWrapper(result);
}
function getMapTagList() {
  return dataWrapper(mapTag);
}
function getMapData(type) {
  const data = mapData[type];
  return dataWrapper(data);
}
function getTicketList() {
  const url = "/merchant/api/merchantParkInfo/merchantParkInfoGrid";
  return apiGet(url, {
    currPage: 1,
    pageSize: 3,
    orderType: "default"
  }).then(res => {
    if (res.status == 200) {
      return res.data.rows;
    } else {
      return [];
    }
  });
}
function getShopList() {
  const url = "/merchant/api/merchantMsdeInfo/listMerchantMsdeInfo";
  return apiGet(url, {
    currPage: 1,
    pageSize: 3,
    orderType: "default"
  }).then(res => {
    if (res.status == 200) {
      return res.data.rows;
    } else {
      return [];
    }
  });
}
function getActivityList(date) {
  const url = "/merchant/activityCalendarApi/getActivityCalendarInfos";
  return apiGet(url, {
    date
  }).then(res => {
    return res.model;
  });
}
function getActivityDetail(id) {
  const url = "/merchant/activityCalendarApi/getActivityCalendarDetail";
  return apiGet(url, {
    activityId: id
  }).then(res => {
    return res.model;
  });
}
function getNavList(corpCode = CorpCode) {
  const url = "/merchant/activityCalendarApi/listMenuTreeByCorpCode";
  return apiGet(url, {
    corpCode
  }).then(res => {
    const result = res.model.list.map(item => {
      const children = item.list.map(child => {
        return {
          label: child.name,
          value: child.id
        };
      });
      return {
        title: item.name,
        icon: item.linkMobileImg || item.picture,
        list: children
      };
    });
    return result;
  });
}
function getArticleDetail(id) {
  const url = "/merchant/activityCalendarApi/getMenuTreeDetail";
  return apiGet(url, {
    id
  }).then(res => {
    return res.model;
  });
}
function getSwiperImg(type = 'toxihu') {
  const url = '/merchant/activityCalendarApi/getListByTitle';
  return apiGet(url, {
    title: type,
    merchantId: localStorage.getItem("m_id")
  }).then(res => {
    return res.model;
  });
}
export {
  getIntroduction,
  getHistory,
  getRelic,
  getLegend,
  getScenicTagList,
  getScenicDes,
  getScenicList,
  getScenicDetail,
  getMapTagList,
  getMapData,
  getTicketList,
  getShopList,
  getActivityList,
  getActivityDetail,
  getNavList,
  getArticleDetail,
  getSwiperImg
};



// WEBPACK FOOTER //
// ./src/api/xihu.js